<template>
  <div
    v-if="!isUaOrGb && (isAddToFreeDelivery || textDelivery)"
    class="side-bar-delivery-free"
    :class="{ _add: isAddToFreeDelivery, _free: !isAddToFreeDelivery }"
  >
    <template v-if="isAddToFreeDelivery">
      <add-goods32 :width="32" :height="32" class="side-bar-delivery-free__icon" />
      <div class="side-bar-delivery-free__text-holder">
        <p class="side-bar-delivery-free__text _normal">
          Добавьте товары на сумму <span class="nobr">{{ leftToGetFreeDeliveryPriceFormatted }}</span>
        </p>
        <p class="side-bar-delivery-free__text _bold">
          {{ textAddToFreeDelivery }}
        </p>
      </div>
    </template>
    <template v-else>
      <check32 :width="32" :height="32" class="side-bar-delivery-free__icon" />
      <p class="side-bar-delivery-free__text _bold">
        {{ textDelivery }}
      </p>
    </template>
    <loader-block v-if="isLoading" text="" class="side-bar-delivery-free__loader" />
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api';
import { LoaderBlock } from '@book24/ui-components';

import { priceFormatted } from '@/utils/formatters/formattedPrice';
import { AMOUNT_DEFAULT_VALUE } from '@/compositions/basket/basketStorage';

import { useLocationContext } from '@/compositions/location/locationStorage';

import Check32 from '@/assets/sprite/svg/32/Check_32.svg';
import AddGoods32 from '@/assets/sprite/svg/32/Add_goods_32.svg';

export default defineComponent({
  name: 'SideBarDeliveryFree',
  components: {
    LoaderBlock,
    Check32,
    AddGoods32,
  },
  props: {
    optimalDeliveryData: { type: Object, default: () => ({ isPvzBook24: false, leftToGetFreeDelivery: null, price: null }) },
    cheapestDeliveries: { type: Array, default: () => ([]) },
    amount: { type: Object, default: () => ({ ...AMOUNT_DEFAULT_VALUE }) },
    isDeletedAll: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isHasFreeDelivery: { type: Boolean, default: false },
  },
  setup(props) {
    const { isUaOrGb, isSpbOrMoscow } = useLocationContext();

    const leftToGetFreeDeliveryPrice = computed(() => {
      if (props.optimalDeliveryData.price <= 0 || !props.optimalDeliveryData.price) {
        return 0;
      }

      return props?.optimalDeliveryData?.leftToGetFreeDelivery ?? 0;
    });

    const leftToGetFreeDeliveryPriceFormatted = computed(() => priceFormatted(
      leftToGetFreeDeliveryPrice.value,
      { setFreeText: false },
    ));

    const isAddToFreeDelivery = computed(() => leftToGetFreeDeliveryPrice.value > 0);

    const isOptimalDeliveryPvzBook24 = computed(() => props?.optimalDeliveryData?.isPvzBook24 ?? false);

    const freeDeliveries = computed(() => props.cheapestDeliveries
      .filter(item => item.type !== 'pvzBook24')
      .filter(item => +item.price === 0));

    const onlyBookPvz = computed(() => {
      const pvzBook = props.cheapestDeliveries.find(item => item.type === 'pvzBook24');
      return pvzBook && +pvzBook.price === 0 && !freeDeliveries.value.length;
    });

    const hasChitaiGorod = computed(() => props.cheapestDeliveries.find(item => item.type === 'pvzChitaiGorod'));

    const hasBookvoed = computed(() => props.cheapestDeliveries.find(item => item.type === 'pvzBookvoed'));

    const textDelivery = computed(() => {
      if (onlyBookPvz.value && isSpbOrMoscow.value) {
        return +props.amount.discounted < 500
          ? 'Бесплатная доставка в пункты выдачи Book24 при оплате онлайн'
          : 'Бесплатная доставка в пункты выдачи Book24';
      }

      if (freeDeliveries.value.length) {
        if (hasChitaiGorod.value && !props.isHasFreeDelivery) return 'Бесплатная доставка в магазины «Читай-город»';
        if (!hasChitaiGorod.value && hasBookvoed.value && !props.isHasFreeDelivery) return 'Бесплатная доставка в магазины «Буквоед»';
        return 'Бесплатная доставка';
      }
    });

    const textAddToFreeDelivery = computed(() => (isOptimalDeliveryPvzBook24.value
      ? 'и мы доставим заказ бесплатно в пункты выдачи Book24'
      : 'и мы доставим заказ бесплатно'));

    return {
      isUaOrGb,
      isAddToFreeDelivery,
      leftToGetFreeDeliveryPrice,
      leftToGetFreeDeliveryPriceFormatted,
      isOptimalDeliveryPvzBook24,
      textDelivery,
      textAddToFreeDelivery,
    };
  },
});
</script>

<style lang="less">
.side-bar-delivery-free {
  display: grid;
  align-items: center;
  grid-template-columns: 32px 1fr;
  grid-gap: @size-x3;
  border-radius: @size-x2;
  position: relative;

  &._free {
    padding: @size-x3 @size-x4;
    background-color: @green-back;
  }

  &._add {
    padding: @size-x3;
    background-color: @gray-back;
  }

  &__icon {
    fill: @green;
  }

  &__text {
    .small();

    margin: 0;

    &._bold {
      font-weight: 700;
    }
  }
}
</style>
